import React from 'react';
import i18n from 'i18next';
import './LoadingSpinner.css';

/**
 * LoadingSpinner - компонент индикатора загрузки
 * @param {string} message - ключ перевода для сообщения (по умолчанию "loading")
 * @param {string} size - размер: 'sm', 'md', 'lg' (по умолчанию 'md')
 * @param {boolean} fullPage - занимать всю страницу (по умолчанию false)
 */
const LoadingSpinner = ({ message = 'loading', size = 'md', fullPage = false }) => {
    const sizeClass = `spinner-${size}`;
    const containerClass = fullPage ? 'loading-container loading-fullpage' : 'loading-container';

    return (
        <div className={containerClass}>
            <div className={`loading-spinner ${sizeClass}`}>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
            </div>
            {message && (
                <p className="loading-text">{i18n.t(message)}</p>
            )}
        </div>
    );
};

export default LoadingSpinner;
